import { styled, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { FormEvent, ReactNode } from 'react';
import { api } from '../lib/api';

function FormLayout(props: {
    children: ReactNode | ReactNode[];
    handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
    title: string;
    subtitle: string;
}) {
    useQuery({ queryFn: api.ping, queryKey: ['ping'], refetchOnWindowFocus: true });
    return (
        <ContentContainer onSubmit={props.handleSubmit}>
            <LogoContainer>
                <Logo src="https://www.esaj.asso.fr/assets/images/logo-sos.svg" />
            </LogoContainer>
            <Title variant="h2">{props.title}</Title>
            <Subtitle variant="h2">{props.subtitle}</Subtitle>
            {props.children}
        </ContentContainer>
    );
}

const Logo = styled('img')(({ theme }) => ({
    width: '200px',
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
}));

const LogoContainer = styled('div')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));

const ContentContainer = styled('form')(({ theme }) => ({
    flex: 1,
    padding: theme.spacing(4),
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
}));

const Title = styled(Typography)(({ theme }) => ({
    textAlign: 'center',
    paddingBottom: theme.spacing(1),
}));

const Subtitle = styled(Typography)(({ theme }) => ({
    textAlign: 'center',
    paddingBottom: theme.spacing(2),
}));

export { FormLayout };
